import React from 'react';
import LabInfoHelp from './LabInfoHelp';

function renderDescription(description) {
  if (!description) return null;
  if (typeof description === 'string') return <p>{description}</p>;
  return <div className="lab-card-description">{description}</div>;
}

export default function LabCard({ title, description, badge, children, actions, help }) {
  return (
    <section className="lab-card">
      <div className="lab-card-header">
        <div className="lab-card-headcopy">
          {badge ? <span className="lab-badge">{badge}</span> : null}
          <div className="lab-title-row">
            <h2>{title}</h2>
            {help ? <LabInfoHelp compact ariaLabel={help.ariaLabel} {...help} /> : null}
          </div>
          {renderDescription(description)}
        </div>
        {actions ? <div className="lab-card-actions">{actions}</div> : null}
      </div>
      {children}
    </section>
  );
}
